import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';

interface GeneralButtonsButtonsPreviousNextSmallSignature {
  Args: {
    beginReached?: boolean;
    dataEventIdNext?: string;
    dataEventIdPrevious?: string;
    endReached?: boolean;
    isDisabled?: boolean;
    nextClicked?: () => void;
    previousClicked?: () => void;
  };
}

export default class GeneralButtonsButtonsPreviousNextSmall extends Component<GeneralButtonsButtonsPreviousNextSmallSignature> {
  @action nextClicked(): void {
    this.args.nextClicked?.();
  }

  @action previousClicked(): void {
    this.args.previousClicked?.();
  }

  <template>
    <div class="mr-100 flex items-center justify-center gap-100">
      <PrismButton
        @buttonType="secondary"
        @icon="chevron-left"
        @isDisabled={{or @isDisabled @beginReached}}
        @onClick={{this.previousClicked}}
        data-event-id={{if
          @dataEventIdPrevious
          @dataEventIdPrevious
          "datepicker-button-previous"
        }}
        data-test-id="datepicker-button-previous"
      />
      <PrismButton
        @buttonType="secondary"
        @icon="chevron-right"
        @isDisabled={{or @isDisabled @endReached}}
        @onClick={{this.nextClicked}}
        data-event-id={{if
          @dataEventIdNext
          @dataEventIdNext
          "datepicker-button-next"
        }}
        data-test-id="datepicker-button-next"
      />
    </div>
  </template>
}
